import { render, staticRenderFns } from "./ConfigureWinRates.vue?vue&type=template&id=df25113a&scoped=true&"
import script from "./ConfigureWinRates.vue?vue&type=script&lang=ts&"
export * from "./ConfigureWinRates.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigureWinRates.vue?vue&type=style&index=0&id=df25113a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df25113a",
  null
  
)

export default component.exports